import { Command } from 'commander'
import as from 'ansis'

import { getAuthData } from '@/helpers'
import { output } from '@/helpers/std-out'

export const WhoAmICommand = () => {
  const cmd = new Command('whoami')

  cmd.description('Display the current user')
  cmd.action(async () => {
    // we don't need to refresh the token
    const auth = await getAuthData({ skipRefresh: true })

    // Displaying the current user information
    output
      .info()
      .message(
        `You are logged in as ${as.cyan(auth.email ?? '')} (role: ${as.cyan(auth.role ?? 'Owner')})`,
      )
      .line()
      .print()
  })

  return cmd
}
